import { render } from "./NavPill.vue?vue&type=template&id=08bb2191"
import script from "./NavPill.vue?vue&type=script&lang=js"
export * from "./NavPill.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__